// Generated types for ResponsePart
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ResponsePartReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When part was created */
  created_at?: string | null;
  /** Order of this part in the response */
  order_index: number;
}

export interface ResponsePartWriteAPI extends ScopedNodeWriteAPI {
  /** Order of this part in the response */
  order_index: number;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ResponsePartReadAPISchemaObject = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  order_index: z.number(),
}).passthrough();
export const ResponsePartReadAPISchema: z.ZodType<ResponsePartReadAPI> = ResponsePartReadAPISchemaObject;

export const ResponsePartWriteAPISchemaObject = ScopedNodeWriteAPISchemaObject.extend({
  order_index: z.number(),
}).passthrough();
export const ResponsePartWriteAPISchema: z.ZodType<ResponsePartWriteAPI> = ResponsePartWriteAPISchemaObject;
